import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

import { FaCheckCircle } from 'react-icons/fa';
import { MdWarning } from 'react-icons/md';

import Button from '../../lib/Button/Button';

import styles from './ValidRow.module.scss';
import { format } from 'date-fns';
import Comment from '../Comment/Comment';
import commentIcon from '../../../assets/images/comment.svg'
import useWindowSize from '../../../hooks/useWindowSize';
import { status } from '../../../utils/utils';
import Modale from '../../lib/Modale/Modale';

export default function ValidRow({ answer, adminId, handleChangeAnswer }) {
  const validator = answer?.validators.find(admin => admin.users?.includes(adminId));
  const answerComments = answer?.validators?.filter((v) => v.comment);
  const { question } = answer;
  const { width } = useWindowSize();
  const [comment, setComment] = useState(null);
  const [modaleIsOpen, setModaleIsOpen] = useState(false);
  function validAnswer() {
    let validators = [...answer.validators];
    validators.forEach(val => {
      if (val.users?.includes(adminId)) {
        val.isValid = !val.isValid;
        val.user = adminId;
      }
    });
    handleChangeAnswer(answer._id, "validators", validators);
  }

  function validComment(text = null) {
    let validators = [...answer.validators];
    if (!text) {
      setComment(null);
    }
    validators.forEach(val => {
      if (val?.user?.toString() === adminId?.toString() || val.users?.includes(adminId?.toString())) {
        val.comment = text;
      }
    });
    handleChangeAnswer(answer._id, "validators", validators);
  }

  useEffect(() => {
    setComment(validator?.comment || null);
  }, [validator]);

  if (width < 1024) {
    return <>
      <div onClick={() => setModaleIsOpen(true)} className={styles.mobile}>
        <div className={styles.question}>
          <div className={styles.infos}>
            <p>
              <span>{question.code}</span>
              {" "}/{" "}
              <span className={styles.author}>
                {question?.author?.lastName && <>{question?.author?.firstName && question?.author?.firstName[0]?.toUpperCase()}{question?.author?.firstName && '.'}{question?.author?.lastName?.toUpperCase()}</>}
                {question?.author?.name && <>{question?.author?.name?.toUpperCase()}</>}
              </span>
            </p>
            <p>
              <span style={{ color: status[question.status].color }}>{status[question.status].label}</span>
              {" "}/{" "}

              {question?.delay >= 7 && <span className="text-error">{question.delay} j</span>}
              {question?.delay < 7 && <span className="text-success">{question.delay} j</span>}
            </p>
          </div>
          <p>{question.title || question.code}</p>
        </div>
        <div className={styles.icons}>
          <div className={styles.valid}>
            {answerComments?.length > 0 && <img src={commentIcon} alt="comment" />}
            {answer?.validators?.map(admin => <FaCheckCircle key={admin._id} size={24} color={admin.isValid ? '#4DCD98' : '#D8D8D8'} />)}
          </div>
        </div>
      </div>
      <Modale
        isOpen={modaleIsOpen}
        modaleToggle={() => setModaleIsOpen(!modaleIsOpen)}
      >
        <div className={styles.modal}>

          <div className={styles.text}>
            <p><span className="bold">Question</span> <span>par {answer.question?.lastName && <p>{answer.question?.firstName[0]?.toUpperCase()} {answer.question?.firstName && '.'} {answer.question?.lastName?.toUpperCase()}</p>} </span></p>
            <p className={styles.p}>{answer.question.question}</p>
          </div>

          <div className={styles.text}>
            <p><span className="bold">Réponse</span> <span>par {answer.question?.assignTo?.profile?.firstName} {answer.question?.assignTo?.profile?.lastName}</span></p>
            {answer?.answer &&
              <div className={styles.p} dangerouslySetInnerHTML={{ __html: answer?.answer }}></div>
            }
          </div>
          {answerComments?.length > 0 &&
            <div className={styles.comments}>
              <label className="bold">Commentaires</label>
              {answerComments?.map((c) => <p className={`comment-${c._id}`}>{c.comment}</p>)}
            </div>
          }
          {validator &&
            <div className={styles.validation}>
              <Button
                onClick={() => validAnswer(false)}
                className={`${styles['valid-btn']} ${!validator?.isValid ? "" : styles.not}`}
              >
                {!validator?.isValid ? "Valider la réponse" : "Refuser la réponse"}
              </Button>

              <div className={styles.comment}>
                {comment !== null ?
                  <>
                    <textarea
                      value={comment}
                      onChange={(e) => setComment(e.target.value)}
                      placeholder="Votre  commentaire"
                    />
                    <button
                      className={styles.submit}
                      onClick={() => validComment(comment)}
                    >
                      Valider
                    </button>
                    <button
                      onClick={() => validComment(null)}
                    >
                      Annuler
                    </button>
                  </>
                  : <button
                    onClick={() => setComment("")}
                    className={styles.toggle}>
                    Laisser un commentaire
                  </button>
                }
              </div>
            </div>
          }
        </div>
      </Modale>
    </>
  }

  return (
    <div className={`${styles.container} box`}>

      <div className={styles.row}>

        <div className={styles.col}>
          <div className={styles.title}>
            <p className={styles.code}>{answer.question.code}</p>
            {answer?.question?.title &&
              <Link to={`/question/${answer.question._id}`} className="bold">
                <p>{answer.question.title}</p>
              </Link>
            }
          </div>
        </div>

        <div className={styles.col}>
          <div className={`${styles.border} ${styles.title}`}>
            <p>{answer.mode.find((m) => m === "written") && "Ecrit"} {answer.mode.length > 1 && " / "} {answer.mode.find((m) => m === "oral") && "Oral"}</p>
          </div>
        </div>

        <div className={`${styles['col-right']} ${styles.delay}`}>
          <p>{answer.question.date && format(new Date(answer.question.date), 'dd/MM/yyyy')}</p>
          <div
            className={`${styles['icons']}`}
          >
            {answer?.validators.every(admin => admin.isValid) && answer?.validators?.map(admin => <FaCheckCircle key={admin._id} size={24} color={admin.isValid ? '#4DCD98' : '#D8D8D8'} />)}
          </div>
          {answer?.delay >= 7 && <p className="text-error">{answer.delay} jours <MdWarning size={18} /></p>}
          {answer?.delay < 7 && <p className="text-success">{answer.delay} jours </p>}
        </div>

      </div>

      {!answer?.validators.every(admin => admin.isValid) &&

        <div className={styles.row}>

          <div className={styles.col}>
            <div className={styles.text}>
              <p><span className="bold">Question</span> <span>par {answer.question?.lastName && <p>{answer.question?.firstName[0]?.toUpperCase()} {answer.question?.firstName && '.'} {answer.question?.lastName?.toUpperCase()}</p>} </span></p>
              <p>{answer.question.question}</p>
            </div>
          </div>

          <div className={styles.col}>
            <div className={styles.text}>
              <p><span className="bold">Réponse</span> <span>par {answer.question?.assignTo?.profile?.firstName} {answer.question?.assignTo?.profile?.lastName}</span></p>
              {answer?.answer &&
                <div dangerouslySetInnerHTML={{ __html: answer?.answer }}></div>
              }
            </div>
          </div>

          <div className={`${styles['col-right']} ${styles['validation-container']}`}>
            <div
              className={`${styles['valid-icons']}`}
            >
              <Comment validators={answer?.validators} />
              {answer?.validators?.map(admin => <FaCheckCircle key={admin._id} size={24} color={admin.isValid ? '#4DCD98' : '#D8D8D8'} />)}
            </div>
            {validator &&
              <>
                <Button
                  onClick={() => validAnswer(false)}
                  className={`${styles['valid-btn']} ${!validator.isValid ? "" : styles.not}`}
                >
                  {!validator.isValid ? "Valider la réponse" : "Refuser la réponse"}
                </Button>

                <div className={styles.comment}>
                  {comment !== null ?
                    <>
                      <textarea
                        value={comment}
                        onChange={(e) => setComment(e.target.value)}
                        placeholder="Votre  commentaire"
                      />
                      <button
                        className={styles.submit}
                        onClick={() => validComment(comment)}
                      >
                        Valider
                      </button>
                      <button
                        onClick={() => validComment(null)}
                      >
                        Annuler
                      </button>
                    </>
                    : <button
                      onClick={() => setComment("")}
                      className={styles.toggle}>
                      Laisser un commentaire
                    </button>
                  }
                </div>
              </>
            }
          </div>

        </div>

      }

    </div>
  )
}
